export default "__VITE_ASSET__DPw6aBUJ__"